<template>
  <v-card flat >
    <v-card flat class="bg-gray zindex-1 pt-2">
      <v-row class="pb-6 mx-3">
        <v-col cols="8" md="8">
          <div class="d-flex">
            <div class="circle-with-text d-none d-sm-flex mr-4">{{ initials }}</div>
            <div>
              <div class="title-icon">
                <div class="d-flex">
                  <h4 class="no-transformed">{{ fullname }}</h4>
                  <p v-if="protectedPerson" class="personalnumber">&nbsp;</p>
                  <p v-else class="personalnumber">{{ maskedPnr }}</p>
                  <p v-if="isProtectedPerson" class="ml-4 mt-3"><b>(Skyddad identitet)</b></p>
                </div>
              </div>
              <h6 v-if="protectedPerson" class="mt-n4">&nbsp;</h6>
              <h6 v-else class="mt-n4">{{ description }}</h6>
            </div>
          </div>
        </v-col>
        <v-col v-if="protectedPerson" class="text-right">
        </v-col>
        <v-col v-else class="text-right">
          <v-btn disabled class="hidden-md-and-down mb-2 ml-2"> <v-icon>$sl-email</v-icon>Skicka meddelande </v-btn>
          <v-btn class="mb-2 ml-2" @click="bankIdClick()"> <v-icon>$sl-bankid</v-icon>Autentisera med Bankid </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-card v-if="protectedPerson" flat class="container--fluid">
      <hr class="mb-12">
      <v-container fill-height>
        <v-layout column align-center justify-center>
          <v-icon size="72" class="mt-12">$sl-user-protect</v-icon>
          <h6 class="mt-8">Du kan inte visa denna person då den har skyddad identitet.</h6>
          <v-btn class="mt-8" to="/people"><v-icon left>$sl-arrow-left</v-icon>ÅTERVÄND TILL PERSONSÖK</v-btn>
        </v-layout>
      </v-container>
    </v-card>

    <v-card v-else flat class="container--fluid">
      <v-tabs v-model="tab" :show-arrows="$vuetify.breakpoint.smAndDown" class="">
        <v-tab>
          <span class="hidden-md-and-down">Kontaktinfo</span>
          <span class="hidden-lg-and-up">Kont.</span>
        </v-tab>
        <v-tab v-if="selectedPerson && selectedPerson.id">
          <span class="hidden-md-and-down">Anställningar</span>
          <span class="hidden-lg-and-up">Anst.</span>
        </v-tab>
        <v-tab v-if="selectedPerson && selectedPerson.id">
          <span class="hidden-md-and-down" data-cy="Intyg">KORT & INTYG</span>
          <span class="hidden-lg-and-up" data-cy="Int">Ko & In.</span>
        </v-tab>
        <v-tab v-if="selectedPerson && selectedPerson.id">
          <span class="hidden-md-and-down">Ärenden</span>
          <span class="hidden-lg-and-up">Är.</span>
        </v-tab>
        <v-tab v-if="selectedPerson && selectedPerson.id">
          <span class="hidden-md-and-down">E-Böcker</span>
          <span class="hidden-lg-and-up">E-Böc.</span>
        </v-tab>
        <v-tab v-if="selectedPerson && selectedPerson.id">
          <span class="hidden-md-and-down">K-Tid</span>
          <span class="hidden-lg-and-up">K-Tid.</span>
        </v-tab>
        <v-tab v-if="selectedPerson && selectedPerson.id">
          <span class="hidden-md-and-down">Beställningar</span>
          <span class="hidden-lg-and-up">Best.</span>
        </v-tab>
        <v-tab v-if="selectedPerson && selectedPerson.id">
          <v-badge :value="personHasNotes" :content="'!'">
            <span class="hidden-md-and-down">Anteckningar</span>
            <span class="hidden-lg-and-up">Ant.</span>
          </v-badge>
        </v-tab>
        <v-tab v-if="selectedPerson && selectedPerson.id">
          <span class="hidden-md-and-down">Inloggningar</span>
          <span class="hidden-lg-and-up">Inl.</span>
        </v-tab>
        <v-tab v-if="selectedPerson && selectedPerson.id">
          <span class="hidden-md-and-down">Administrera</span>
          <span class="hidden-lg-and-up">Admin</span>
        </v-tab>

        <v-tab-item>
          <v-card flat>
            <v-card-text class="no-margins">
              <PersonContactInfo :isNew="Boolean(selectedPerson && selectedPerson.id)" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="selectedPerson && selectedPerson.id">
          <v-card flat>
            <v-card-text class="mt-3">
              <PersonEmployments @saved="fetchPerson()"/>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="selectedPerson && selectedPerson.id" class="mx-6 mt-8">
          <PersonTradeCertificates />
        </v-tab-item>
        <v-tab-item v-if="selectedPerson && selectedPerson.id" class="mx-6 mt-6">
          <PersonCases @fetch-person="fetchPerson()" />
        </v-tab-item>
        <v-tab-item v-if="selectedPerson && selectedPerson.id">
          <v-card flat>
            <v-card-text>
              <PersonEbooks />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="selectedPerson && selectedPerson.id">
          <v-card flat>
            <v-card-text>
              <PersonQualificationTime />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="selectedPerson && selectedPerson.id" class="mx-6 mt-6">
          <PersonDistanceOrders />
        </v-tab-item>
        <v-tab-item v-if="selectedPerson && selectedPerson.id" class="mx-6 mt-6">
          <PersonNotes />
        </v-tab-item>
        <v-tab-item v-if="selectedPerson && selectedPerson.id" class="mx-6 mt-6">
          <PersonLoginLog />
        </v-tab-item>
        <v-tab-item v-if="selectedPerson && selectedPerson.id" class="mx-6 mt-6">
          <PersonAdministration />
        </v-tab-item>
      </v-tabs>
    </v-card>

    <v-dialog v-model="bankIdDialog" max-width="600px">
      <v-card flat>
        <v-icon class="close" @click="closeBankId()">$sl-close</v-icon>
        <v-card-title v-if="showContent == 'ok'">Autentisera {{ firstName + ' ' + lastName }}</v-card-title>
        <v-card-title v-else>Autentisera {{ fullname }}</v-card-title>

        <v-card-text class="mt-2" v-if="selectedPerson && showContent == 'wait'">
          Be {{ selectedPerson.firstName || fullname }} öppna appen BankID på telefonen eller datorn och legitimera sig.
          <div class="d-flex justify-center mt-2">
            <div class="byn-spinner-rolling">
              <div class="byn-spinner">
                <div></div>
              </div>
            </div>
          </div>
          <p align="center" class="mt-4">
            <i>Väntar på att {{ fullname }} ska legitimera sig med BankID…</i>
          </p>
        </v-card-text>

        <v-card-text class="bankIdDialog bankIdDialog--ok" v-else-if="showContent == 'ok'">
          <div class="bankIdDialog--icon">
            <v-icon>$sl-check</v-icon>
          </div>
          <p>
            <span class="text-uppercase">{{ firstName + ' ' + lastName }}</span> har legitimerat sig med BankID och
            identiteten är bekräftad.
          </p>
        </v-card-text>
        <v-card-text class="bankIdDialog bankIdDialog--fail" v-else>
          <div class="bankIdDialog--icon">
            <v-icon>$sl-deny</v-icon>
          </div>
          <p>{{ failureText }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import PersonContactInfo from '@/components/person/PersonContactInfo'
import PersonEmployments from '@/components/person/PersonEmployments'
import PersonTradeCertificates from '@/components/person/PersonTradeCertificates'
import PersonCases from '@/components/person/PersonCases'
import PersonLoginLog from '@/components/person/PersonLoginLog'
import PersonNotes from '@/components/person/PersonNotes'
import PersonAdministration from '@/components/person/PersonAdministration'
import PersonDistanceOrders from '@/components/person/PersonDistanceOrders'
import PersonEbooks from '@/components/person/PersonEbooks/PersonEbooks'
import PersonQualificationTime from '@/components/person/qualificationtime/PersonQualificationTime'
import {CompanyRoles} from '@/components/mixins'
import orderBy from 'lodash/orderBy'
import filter from 'lodash/filter'

import _get from 'lodash/get'
import flatMap from 'lodash/flatMap'

// @group Person
// PersonDetail component
export default {
  name: 'PersonDetail',

  components: {
    PersonContactInfo,
    PersonEmployments,
    PersonTradeCertificates,
    PersonCases,
    PersonLoginLog,
    PersonNotes,
    PersonAdministration,
    PersonDistanceOrders,
    PersonEbooks,
    PersonQualificationTime
  },

  mixins: [CompanyRoles],

  data: function () {
    return {
      tab: this.$route.query.tab ? Number(this.$route.query.tab) : 0,
      bankIdDialog: false,
      showContent: 'wait',
      failureText: 'Identifieringen misslyckades',
      firstName: '',
      lastName: '',
      personHasNotes: Boolean(_get(this, 'selectedPerson.notes', []).length)
    }
  },

  created() {
    this.fetchPerson()
  },

  watch: {
    '$route.query.tab': {
      handler: function(val) {
        if ( val !== '7' )
          this.fetchNotes()
      },
      immediate: true
    },
    '$route.params.id': {
      handler: (newVal, OldVal) => {
        this.fetchPerson()
      }
    },
    selectedPerson: {
      handler: function () {
        this.tab = Number(this.$route.query.tab)
      }
    },
    tab: {
      handler: function (newVal, oldVal) {
        if (!this.selectedPerson || newVal === Number(this.$route.query.tab) || Number.isNaN(newVal)) return
        this.$router.replace({query: {tab: Number(newVal)}})
      }
    }
  },

  computed: {
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),

    protectedPerson() {
      return _get(this, 'selectedPerson.isProtected', false) && this.currentUserRole === 'region'
    },

    isProtectedPerson() {
      return Boolean(_get(this, 'selectedPerson.isProtected', false))
    },

    initials() {
      let i1 = this.selectedPerson && this.selectedPerson.firstName ? this.selectedPerson.firstName.charAt(0) : '-'
      let i2 = this.selectedPerson && this.selectedPerson.lastName ? this.selectedPerson.lastName.charAt(0) : '-'
      return i1 + i2
    },
    fullname() {
      let n1 = this.selectedPerson && this.selectedPerson.firstName ? this.selectedPerson.firstName : '-'
      let n2 = this.selectedPerson && this.selectedPerson.lastName ? this.selectedPerson.lastName : ''
      if (n1 == '-' && n2 == '') {
        if (this.selectedPerson && this.selectedPerson.personalNumber) {
          return this.selectedPerson.personalNumber.substring(0, 8) + '-****'
        }
      }
      return n1 + ' ' + n2
    },
    description() {
      let descStr = ''

      const employments = orderBy(filter(_get(this, 'selectedPerson.employments', []), ['manuallyEndedDate', null]), function(o) { return o.fromDate }, 'desc')
      const apprenticeships = orderBy(filter(_get(this, 'selectedPerson.apprenticeships', []), ['manuallyEndedDate', null]), function(o) { return o.fromDate }, 'desc')

      if (employments?.length) {
        descStr = this.getRoleDescription(employments[0])
        descStr = descStr.split(', ')

        if(descStr.length > 1) {
          descStr = descStr.map((str, idx) => idx === 0 ? str.charAt(0).toUpperCase() + str.substring(1).toLowerCase() : str.toLowerCase()).join(', ')
        }

        descStr += ' (' + employments[0].company.name + ')'
        return descStr
      }
      if (apprenticeships?.length) {
        descStr = apprenticeships[0].profession.name + ' lärling'
        descStr += ' (' + apprenticeships[0].company.name + ')'
        return descStr
      }
    },
    maskedPnr() {
      if (this.selectedPerson && this.selectedPerson.personalNumber) {
        return this.selectedPerson.personalNumber.substring(0, 8) + '-****'
      }
      return ''
    }
  },

  methods: {
    ...mapActions('person', ['setSelectedPerson']),

    fetchNotes() {
      API.listNotes ({
        startAt: 0,
        sortBy: 'createdAt',
        sortDesc: 'DESC',
        search: '',
        advSearch: { personId: Number(_get(this, '$route.params.id', null)) },
        pageSize: 500
      })
      .then(response => {
        const hasOrderComments = flatMap(_get(this, 'selectedPerson.distanceOrders', []), 'comments').length
        this.personHasNotes = Boolean(_get(response, 'data.count', 0) || hasOrderComments)
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
    },
    /**
     * @vuese
     * Used to confirm person with bankId
     */
    bankIdClick() {
      this.bankIdDialog = true
      this.showContent = 'wait'

      if (!this.selectedPerson || !this.selectedPerson.personalNumber) {
        this.showContent = ''
        this.failureText = 'Identifieringen misslyckades då personnumret saknas.'
        return
      }
      //- Start BankId
      let data = {personalNumber: this.selectedPerson.personalNumber}
      API.personVerify(data)
        .then(res => {
          if (res.data && res.data.verified == true) {
            this.firstName = res.data.firstName
            this.lastName = res.data.lastName
            this.showContent = 'ok'
          } else {
            this.showContent = ''
            if (res.data && res.data.error) {
              switch (res.data.error) {
                case 'alreadyInProgress':
                  this.failureText =
                    'En identifiering eller underskrift för det här personnumret är redan påbörjad. Försök igen.'
                  break

                case 'cancelled':
                  this.failureText = 'Identifieringen blev avbruten. Försök igen.'
                  break

                case 'certificateErr':
                  this.failureText = 'Identifieringen misslyckades då fel kod angavs för många gånger.'
                  break

                case 'expiredTransaction':
                  this.failureText =
                    'BankID-appen svarar inte. Kontrollera att den är startad och internetanslutning finns. Försök igen.'
                  break

                case 'requestTimeout':
                  this.failureText = 'Internt tekniskt fel. Försök igen.'
                  break

                case 'Timeout':
                  this.failureText = 'Identifieringen misslyckades då den tog för lång tid.'
                  break

                case 'userCancel':
                  this.failureText = 'Identifieringen blev avbruten av ' + this.fullname + '.'
                  break

                default:
                  this.failureText = 'Identifieringen misslyckades.'
              }
            }
          }
        })
        .catch(error => {
          console.log('There was an error:', error)
          this.showContent = ''
          this.failureText =
            'Identifieringen misslyckades. Kontrollera att personnumret stämmer och att giltigt BankID finns.'
        })
    },
    closeBankId() {
      this.bankIdDialog = false
    },
    /**
     * @vuese
     * Used to fetch person
     * @arg The argument is integer values representing person id
     */
    fetchPerson() {
      if (this.$route && this.$route.params && this.$route.params.id) {
        API.getPerson(this.$route.params.id)
          .then(response => {
            /**
             * @vuese
             * Used to update local store with the person data
             * @arg the argument is an object representing person
             */
            this.setSelectedPerson(response.data)            
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      } else {
        /**
         * @vuese
         * Used to update local store with an empty person fields object
         * @arg the argument is an object representing person
         */
        //- Not from SPAR?
        if (!(this.selectedPerson && this.selectedPerson.personalNumber && !this.selectedPerson.id)) {
          this.setSelectedPerson({
            country: 'SE',
            personalNumberType: 1
          })
        }
      }
    }
  }
}
</script>
